<script lang="ts">
  import { onMount } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';

  import PreorderLanding from '../../preorder/components/PreorderLanding.svelte';
  import { getTabDetails } from '../../preorder/services/preorder-data-services';
  import { getCMSComponentsFromHybrisAsync } from '../services/hybris';
  export let metaData;
  let loaded: boolean = false;
  let tabsData = [];
  let selectedTab = '';
  let initialized: boolean = false;
  let selectedTabDetails: any = [];
  const { encodedContextPath } = getAppConfig();

  export function onLoad() {
    return loadComponent();
  }

  async function loadComponent() {
    const tabs = metaData?.tabs;
    if (!tabs) {
      return false;
    }
    try {
      return getCMSComponentsFromHybrisAsync(tabs.split(' '))
        .then((res: any) => res.component)
        .then(
          compArray =>
            (tabsData = compArray
              .map(v => ({
                ...metaData,
                ...v,
              }))
              .sort((a, b) => a.displayOrder - b.displayOrder))
        )
        .then(ld => (loaded = ld.length > 0));
    } catch (err) {
      console.error(err);
    }
  }

  function preorderTabClickHandle(tab) {
    if (selectedTab === tab?.uid) return;
    window['ACC'].loader.showLoader();
    selectedTab = tab?.uid;
    const url = `${window.location.pathname.replace(/\/[^/]*$/, '')}/${selectedTab}`;
    window.history.pushState({}, '', url);
  }

  function getTabFromPath() {
    const path = window.location.pathname;
    return path.split('/').filter(Boolean).pop();
  }

  $: if (!initialized && loaded && tabsData?.length) {
    initialized = true;
    const currentTab = getTabFromPath();
    const validTab = tabsData.find(tab => tab.uid === currentTab);
    selectedTab = validTab ? currentTab : tabsData?.[0]?.uid;

    if (!validTab) {
      const preorderUrl = window.location.pathname;
      const windowPathName = preorderUrl.split('/pl');
      const preorderPagename = windowPathName?.[1]
        .split('/')
        ?.map(x => x.trim())
        .filter(Boolean);

      if (preorderPagename?.length === 1) {
        const finalUrl = preorderUrl.endsWith('/') ? `${preorderUrl}${selectedTab}` : `${preorderUrl}/${selectedTab}`;
        history.replaceState({}, '', finalUrl);
      } else {
        history.replaceState({}, '', `${encodedContextPath}/pl/${preorderPagename?.[0]}/${selectedTab}`);
      }
    }
    //const url = `${window.location.pathname.replace(/\/[^/]*$/, '')}/${selectedTab}`;
    //window.history.pushState({}, '', url);
  }

  $: if (selectedTab) {
    selectedTabDetails = getTabDetails(tabsData, selectedTab);
  }
  onMount(() => {
    const updateFromPath = () => {
      selectedTab = selectedTab = getTabFromPath();
    };

    window.addEventListener('popstate', updateFromPath);

    return () => {
      window.removeEventListener('popstate', updateFromPath);
    };
  });
</script>

{#if loaded && tabsData.length > 0}
  <div class="d-flex gap-5 c_cmstabs preorder">
    {#each tabsData as tab}
      <button
        type="button"
        class="d-flex me-3 me-md-5 divider pipe"
        class:active={selectedTab === tab?.uid}
        on:click={() => preorderTabClickHandle(tab)}
        on:touchend={() => preorderTabClickHandle(tab)}
      >
        {tab?.tabName}
      </button>
    {/each}
  </div>

  {#key selectedTab}
    <PreorderLanding bannerDetails={selectedTabDetails} metaData={tabsData} {selectedTab} />
  {/key}
{:else}
  <div class="skeleton-container">
    <div class="skeleton-item">&nbsp;</div>
    <div class="skeleton-item">&nbsp;</div>
    <div class="skeleton-item">&nbsp;</div>
    <div class="skeleton-item">&nbsp;</div>
    <div class="skeleton-item">&nbsp;</div>
  </div>
{/if}

<style lang="scss">
  @import '../styles/colors.new.scss';
  .skeleton-container {
    display: flex;
    gap: 12px;
    .skeleton-item {
      flex-shrink: 0;
      line-height: 24px;
      width: 150px;
      padding: 8px 12px;
      border-radius: 10px;

      @include desktop-min-width {
        line-height: 18px;
        width: 200px;
        padding: 10px 16px;
        border-radius: 100px;
      }
    }
  }
</style>
